import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Divider.module.scss'

interface DividerProps {
  vertical?: boolean
}

export const Divider: React.FC<DividerProps> = ({ vertical = false }) => (
  <hr className={cx(styles.divider, vertical && styles.vertical)} />
)
